<template>
  <div
    class="CropCanvas"
    ref="content"
  >
    <!-- 画布 -->
    <div
      class="sourceCanvas"
      :style="
        `
        height: ${containerHeight}px;
        width: ${containerWidth}px;
        zoom: ${containerZoom};
        backgroundImage:url(${imgUrl}) `
      "
    >
      <div
        class="background"
        :style="
          `
        backgroundImage:url(${backgroundUrl ? backgroundUrl : imgUrl}) `
        "
      >
        <div
          class="backgroundBox"
          v-if="!backgroundUrl || (backgroundUrl && /.*(\.png|\.jpg|\.jpeg|\.gif|\.PNG|\.JPG|\.JPEG|\.GIF)$/g.test(backgroundUrl))"
          :style="`width: 100%;height: 100%;backgroundImage:url(${backgroundUrl ? backgroundUrl : imgUrl})`"
        ></div>
        <iframe
          v-else
          :src="`${backgroundUrl ? backgroundUrl : imgUrl}`"
          frameborder="0"
          style="transform-origin: 0 0;"
          :style="`transform: scale(${containerZoom}); width:${containerWidth/containerZoom}px; height: ${containerHeight/containerZoom}px`"
        ></iframe>
      </div>
      <!-- Source的父盒子大小为了拉伸浏览器子盒子跟着改变 -->
      <div
        :style="
          `
          height:${containerHeight}px;
          width:${containerWidth}px;
          marginTop: ${top}px;
          position: relative;transform-origin: left top;`
        "
        v-if="containerWidth != 0"
      >
        <!-- Drag Lband -->
        <DragLBand
          :lBandInfo="lBandInfo"
          @cropComp="cropComponent"
          :parentStyle="{ containerWidth, containerHeight }"
        ></DragLBand>
      </div>
    </div>
  </div>
</template>
<script>
import DragLBand from './DragLBand'
import Bus from '@/assets/js/vueBus.js'

export default {
  name: 'LBandCanvas',
  components: {
    DragLBand
  },
  props: {
    currentName: {
      type: String,
      default: ''
    },
    // 编辑的lBand信息
    lBandInfo: {
      type: Object,
      default: () => ({})
    },
    // 所选分辨率
    VideoResolution: {
      type: Object,
      default: () => ({
        width: 1920,
        height: 1080
      })
    }
  },
  data () {
    return {
      containerWidth: 1920,
      containerHeight: 1080,
      containerZoom: 1,
      top: 0,
      cropListObj: Object.create({}),
      imgUrl: require('./quad-default.png'),
      duration: 0,
      squeeze: 0,
      productionId: '',
      programId: '',
      userId: '',
      // 背景图片url
      backgroundUrl: ''
    }
  },
  created () {
    Bus.$on('resize', this.resize)
    Bus.$on('updateLBandCanvas', this.backUpdate)
    this.containerWidth = this.VideoResolution.width
    this.containerHeight = this.VideoResolution.height
    if (this.lBandInfo.url) {
      this.backgroundUrl = this.lBandInfo.url
    }
  },

  async mounted () {
    await this.getWidthAndMargin()
  },
  methods: {
    async resize () {
      await this.getWidthAndMargin()
    },
    async getWidthAndMargin () {
      // 容器的内边距
      const padding = 40
      // 获取浏览器的宽
      this.$nextTick(() => {
        const dom = this.$refs.content
        let width = 0
        let height = 0
        // 容器的宽度的浏览器获取到的父盒子宽度-padding
        width = Number((dom.clientWidth - padding * 2).toFixed(0))
        height = Number(((width * 9) / 16).toFixed(0))
        if (height >= width) {
          height = Number((dom.clientHeight - padding * 2).toFixed(0))
          width = Number(((height * 16) / 9).toFixed(0))
        }
        this.containerZoom = width / this.containerWidth
        this.top = Number(((dom.clientHeight - height) / 2).toFixed(0))
      })
    },
    // 获取每一个DragAbdCrop子组件
    cropComponent (data) {
      if (typeof data != 'object') {
        delete this.cropListObj[data]
        return
      }
      const { id, components } = data
      this.cropListObj[id] = components
    },
    // 背景图片更新
    backUpdate (data) {
      if (data.type == 'background') {
        this.backgroundUrl = data.url
      }
    }
  },
  beforeDestroy () {
    Bus.$off('resize')
  }
}
</script>
<style lang="less">
.CropCanvas {
  float: right;
  width: calc(100% - 384px);
  height: calc(100% - 64px);

  .sourceCanvas {
    position: relative;
    margin: 0 auto;
    margin-top: 12px;
    background-repeat: no-repeat !important;
    background-size: contain;
    background-position-x: center;
    background-position-y: center;

    .background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat !important;
      background-size: contain;
      background-position-x: center;
      background-position-y: center;
    }

    .backgroundBox {
      background-repeat: no-repeat !important;
      background-size: contain;
      background-position-x: center;
      background-position-y: center;
    }
  }
}
</style>
